import { EMPTY_ARRAY } from 'commons-ui';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.homePageLayout,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayoutOrder,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.homePageLayout,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].removeLayoutOrder,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		backAction: {
			name: 'Back',
			id: 'back'
		},
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.homePageLayout,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createLayoutOrder,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
